import { FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { type ActiveQualificationWithLicenses } from "@src/appV2/redesign/Documents/components/IndependentContractorBadge/hooks/useActiveQualificationsWithLicenses";
import { PageFooter, Title } from "@src/appV2/redesign/system/ui-components";
import { PageContent } from "@src/appV2/redesign/WorkerShifts/components/PageContent";

interface ProfileWorkBadgesSelectRoleProps {
  onContinue: () => void;
  activeQualifications: ActiveQualificationWithLicenses[];
  selectedQualificationId: string | undefined;
  handleQualificationSelect: (qualificationId: string) => void;
  onBack: () => void;
}

export function ProfileWorkBadgesSelectRole(props: ProfileWorkBadgesSelectRoleProps) {
  const {
    onContinue,
    activeQualifications,
    selectedQualificationId,
    handleQualificationSelect,
    onBack,
  } = props;

  return (
    <>
      <StickyScrollPageHeader
        title="Select the Role for Your Badge"
        headerVariant="tertiary"
        onClickBack={onBack}
      />
      <PageContent>
        <RadioGroup
          value={selectedQualificationId}
          onChange={(event) => {
            handleQualificationSelect(event.target.value);
          }}
        >
          <Stack spacing={3}>
            {activeQualifications.map((item) => (
              <FormControlLabel
                key={item.qualification.id}
                value={item.qualification.id}
                control={<Radio />}
                labelPlacement="start"
                label={
                  <Title bold component="h5">
                    {item.qualification.attributes.displayLabel}
                  </Title>
                }
                sx={{
                  justifyContent: "space-between",
                }}
              />
            ))}
          </Stack>
        </RadioGroup>
      </PageContent>

      <PageFooter>
        <Button fullWidth size="large" disabled={!selectedQualificationId} onClick={onContinue}>
          Continue
        </Button>
      </PageFooter>
    </>
  );
}
